import './index.scss';
import { MVPDataTableInternal } from './table';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton } from '@mui/material';
import React from 'react';
import { MVPFiltersProps } from '../constants';

export const MVPArchieved: React.FC<MVPFiltersProps> = ({
  onNavigate,
  onBack,
}) => {
  return (
    <div>
      <div
        style={{
          marginLeft: 10,
          marginTop: 100,
          marginBottom: 50,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: 20,
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}>
          <IconButton
            className="close-icon-btn"
            type="button"
            onClick={onBack}>
            <ArrowBackIcon className="close-icon" />
          </IconButton>

          <span style={{ fontWeight: 600 }}>
            Archived Reports
          </span>
        </div>
      </div>

      <div style={{ marginLeft: 20, marginRight: 10 }}>
        <MVPDataTableInternal
          type={'RECEIVED'}
          onNavigate={onNavigate}
        />
      </div>
    </div>
  );
};
